import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import SubSections from '~/constants/subSections';
import ModalContext from '~/context/vdp/ModalContext';
import PlugIcon from '~/icons/PlugIcon';
import { Card, EvTaxCreditPill } from './AboutThePrice.styles';

const EvTaxCreditCard = () => {
  const { setEvTaxCreditModalOpen } = useContext(ModalContext);

  return (
    <Card id={SubSections.EvTaxCredit} className="gap-16">
      <EvTaxCreditPill>
        <PlugIcon />
        EV Credit
      </EvTaxCreditPill>
      <section className="mb-auto flex flex-col gap-8">
        <h3 className="text-blue-6 t-header-m">Up to $4,000 in savings</h3>
        <p className="text-grey-5 t-body-s m:t-body-m">
          This vehicle may qualify for the Previously-Owned Clean Vehicle tax
          credit made available to taxpayers in the Inflation Reduction Act.
        </p>
      </section>
      <Clickable
        data-analytics-id="ev-card-read-more"
        className="text-blue-2 underline t-body-s m:t-body-m"
        onClick={() => setEvTaxCreditModalOpen(true)}
      >
        Learn More
      </Clickable>
    </Card>
  );
};

export default EvTaxCreditCard;
